import { render, staticRenderFns } from "./ActCategoryForm.vue?vue&type=template&id=163c857f"
import script from "./ActCategoryForm.vue?vue&type=script&lang=js"
export * from "./ActCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('163c857f')) {
      api.createRecord('163c857f', component.options)
    } else {
      api.reload('163c857f', component.options)
    }
    module.hot.accept("./ActCategoryForm.vue?vue&type=template&id=163c857f", function () {
      api.rerender('163c857f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/extension/ActCategoryForm.vue"
export default component.exports